<div class="login-page">
  <div class="box-white">
    <h1>Esqueci minha senha</h1>
    <p class="subtitle">Informe o e-mail da sua conta para receber o link de redefinição.</p>

    <form *ngIf="!success" (ngSubmit)="submit()" [formGroup]="form" class="p-field">
      <div class="form-control" [ngClass]="{'invalid': isInvalid(form.get('email'))}">
        <i class="icon pi pi-envelope"></i>
        <span class="p-float-label">
          <input type="email" formControlName="email" id="email" name="email" pInputText autocomplete="email">
          <label for="email">E-mail *</label>
        </span>
      </div>
      <div class="buttons">
        <button type="submit" [disabled]="!form.valid" class="easy-button full-width" pButton label="Enviar link"></button>
      </div>
    </form>

    <div *ngIf="success" class="success-block">
      <i class="pi pi-check-circle success-icon"></i>
      <p class="success-message">{{ message }}</p>
      <button type="button" class="easy-button" pButton label="Voltar ao login" (click)="goToLogin()"></button>
    </div>

    <div *ngIf="message && !success" class="alert alert-danger text-center error-message">
      <strong>{{ message }}</strong>
    </div>

    <div *ngIf="!success" class="back-link">
      <a routerLink="/login">Voltar ao login</a>
    </div>
  </div>
</div>
